import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Input, Table, Button, Select, Dropdown, Menu, DatePicker, Modal as AntModal, Spin, message } from "antd";
import { DownOutlined, EyeOutlined, EditOutlined, CommentOutlined, UserOutlined, FileAddOutlined, CalendarOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import dayjs from "dayjs";
import Cookies from 'js-cookie';
import customParseFormat from "dayjs/plugin/customParseFormat";
// import "../../antdstyle.css";
import "../components/caseStyle.css";
import {
    getImportantRunningCaseApi,
    getFinalResultApi,
    getHearingDatesByCaseEntryApi,
    createHearingDateApi,
    deleteHearingDateApi,
    updateCaseEntryCommentApi,
    getResponsibleOfficersApi,
    createResponsibleOfficersApi,
    getDocumentsByCaseEntryApi,
    addDocumentApi,
    deleteDocumentApi
} from "../../../api/master.api";
import { uploadGeneralCaseFileApi } from "../../../api/uploadFile.api";
// import Api from "../../../initialpage/hooks/Api";

const { Option } = Select;
const dateFormat = "YYYY-MM-DD";
dayjs.extend(customParseFormat);

const ImportantCase = () => {
    const logInStatus = parseInt(Cookies.get("Role"));

    const toBnDigits = (value) => {
        if (!value) return '';
        const en = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const bn = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
        return String(value).replace(/[0-9]/g, d => bn[en.indexOf(d)]);
    };

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    // Modal States
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [finalResultData, setFinalResultData] = useState({});
    const [modalLoading, setModalLoading] = useState(false);

    const [isHearingModalVisible, setIsHearingModalVisible] = useState(false);
    const [selectedCaseId, setSelectedCaseId] = useState(null);
    const [hearingFormData, setHearingFormData] = useState({
        hearing_date: '',
        next_hearing_date: '',
        hearing_notes: ''
    });
    const [hearingDates, setHearingDates] = useState([]);
    const [hearingModalLoading, setHearingModalLoading] = useState(false);

    const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
    const [commentCaseId, setCommentCaseId] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [commentModalLoading, setCommentModalLoading] = useState(false);

    const [isOfficerModalVisible, setIsOfficerModalVisible] = useState(false);
    const [officerModalLoading, setOfficerModalLoading] = useState(false);
    const [officerCaseId, setOfficerCaseId] = useState(null);
    const [officers, setOfficers] = useState([{ name: '', profession: '', phone: '' }]);

    const [isDocumentModalVisible, setIsDocumentModalVisible] = useState(false);
    const [documentModalLoading, setDocumentModalLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [docFormData, setDocFormData] = useState({ document_name: "", file: null });

    // Fetch important running cases
    useEffect(() => {
        fetchImportantCases();
    }, []);

    const fetchImportantCases = async () => {
        setLoading(true);
        try {
            const response = await getImportantRunningCaseApi();
            if (response.data.success) {
                setData(response.data.data);
            } else {
                message.error("ডাটা লোড করতে সমস্যা হয়েছে");
            }
        } catch (error) {
            console.error('Error fetching important cases:', error);
            message.error("ডাটা লোড করতে ব্যর্থ হয়েছে");
        } finally {
            setLoading(false);
        }
    };
    // console.log(data)
    // Fetch Final Result Data
    const fetchFinalResultData = async (caseEntryId) => {
        setModalLoading(true);
        try {
            const response = await getFinalResultApi(caseEntryId);
            if (response.data.success) {
                setFinalResultData(response.data.data || {});
                setIsModalVisible(true);
            } else {
                message.error("ফাইনাল রেজাল্ট ডাটা লোড করতে ব্যর্থ");
            }
        } catch (error) {
            console.error("Error fetching final result data:", error);
            message.error("একটি ত্রুটি হয়েছে");
        } finally {
            setModalLoading(false);
        }
    };

    // Hearing Date Functions
    const handleHearingDateClick = async (record) => {
        setSelectedCaseId(record.case_entry_id);
        setIsHearingModalVisible(true);
        setHearingModalLoading(true);
        try {
            const response = await getHearingDatesByCaseEntryApi(record.case_entry_id);
            if (response.data.success) {
                setHearingDates(response.data.data || []);
            } else {
                setHearingDates([]);
            }
        } catch (err) {
            console.error('Error fetching hearing dates:', err);
            setHearingDates([]);
            message.error("শুনানি তারিখ লোড করতে ব্যর্থ");
        } finally {
            setHearingModalLoading(false);
        }
    };

    const handleHearingFormSubmit = async () => {
        if (!hearingFormData.hearing_date) {
            message.warning('সর্বশেষ শুনানির তারিখ ফিল্ড পূরণ করুন');
            return;
        }
        setHearingModalLoading(true);
        try {
            const response = await createHearingDateApi({
                case_entry_id: selectedCaseId,
                hearing_date: hearingFormData.hearing_date,
                next_hearing_date: hearingFormData.next_hearing_date,
                hearing_notes: hearingFormData.hearing_notes
            });
            if (response.data.success) {
                message.success('শুনানি তারিখ সফলভাবে যোগ করা হয়েছে');
                // Refresh hearing dates
                const refreshResponse = await getHearingDatesByCaseEntryApi(selectedCaseId);
                if (refreshResponse.data.success) {
                    setHearingDates(refreshResponse.data.data || []);
                }
                setHearingFormData({ hearing_date: '', next_hearing_date: '', hearing_notes: '' });
            } else {
                message.error('শুনানি তারিখ যোগ করতে ব্যর্থ');
            }
        } catch (err) {
            console.error('Error adding hearing date:', err);
            message.error('একটি ত্রুটি হয়েছে');
        } finally {
            setHearingModalLoading(false);
        }
    };

    const handleDeleteHearingDate = async (hearingId) => {
        try {
            const response = await deleteHearingDateApi(hearingId);
            if (response.data.success) {
                message.success('শুনানি তারিখ মুছে ফেলা হয়েছে');
                const refreshResponse = await getHearingDatesByCaseEntryApi(selectedCaseId);
                if (refreshResponse.data.success) {
                    setHearingDates(refreshResponse.data.data || []);
                }
            } else {
                message.error('শুনানি তারিখ মুছতে ব্যর্থ');
            }
        } catch (err) {
            console.error('Error deleting hearing date:', err);
            message.error('একটি ত্রুটি হয়েছে');
        }
    };

    // Comment Functions
    const handleCommentClick = async (record) => {
        setCommentCaseId(record.case_entry_id);
        setCommentText(record.case_comment || '');
        setIsCommentModalVisible(true);
    };

    const handleCommentSubmit = async () => {
        if (!commentText.trim()) {
            message.warning('মন্তব্য ফিল্ড পূরণ করুন');
            return;
        }
        setCommentModalLoading(true);
        try {
            const response = await updateCaseEntryCommentApi({
                case_entry_id: commentCaseId,
                case_comment: commentText.trim()
            });
            if (response.data.success) {
                message.success('মন্তব্য সফলভাবে আপডেট করা হয়েছে');
                setIsCommentModalVisible(false);
                fetchImportantCases();
            } else {
                message.error('মন্তব্য আপডেট করতে ব্যর্থ');
            }
        } catch (err) {
            console.error('Error updating comment:', err);
            message.error('একটি ত্রুটি হয়েছে');
        } finally {
            setCommentModalLoading(false);
        }
    };

    // Responsible Officers Functions
    const handleResponsibleOfficerClick = async (record) => {
        setOfficerCaseId(record.case_entry_id);
        setIsOfficerModalVisible(true);
        setOfficerModalLoading(true);
        try {
            const response = await getResponsibleOfficersApi(record.case_entry_id);
            if (response.data.success) {
                const items = response.data.data || [];
                const mapped = items.map(item => ({
                    name: item.name || '',
                    profession: item.profession || '',
                    phone: item.phone || ''
                }));
                setOfficers(mapped.length ? mapped : [{ name: '', profession: '', phone: '' }]);
            } else {
                setOfficers([{ name: '', profession: '', phone: '' }]);
            }
        } catch (err) {
            console.error('Error fetching responsible officers:', err);
            setOfficers([{ name: '', profession: '', phone: '' }]);
            message.error("কর্মকর্তার তথ্য লোড করতে ব্যর্থ");
        } finally {
            setOfficerModalLoading(false);
        }
    };

    const handleSaveResponsibleOfficers = async () => {
        const cleaned = officers
            .map(o => ({ name: o.name.trim(), profession: o.profession.trim(), phone: o.phone.trim() }))
            .filter(o => o.name || o.profession || o.phone);
        if (!cleaned.length) {
            message.warning('কমপক্ষে একটি সারিতে তথ্য দিন');
            return;
        }
        setOfficerModalLoading(true);
        try {
            const response = await createResponsibleOfficersApi({
                case_entry_id: officerCaseId,
                officers: cleaned
            });
            if (response.data.success) {
                message.success('দায়িত্বপ্রাপ্ত কর্মকর্তাদের তথ্য সংরক্ষণ করা হয়েছে');
                setIsOfficerModalVisible(false);
            } else {
                message.error('তথ্য সংরক্ষণ ব্যর্থ হয়েছে');
            }
        } catch (err) {
            console.error('Error saving responsible officers:', err);
            message.error('একটি ত্রুটি হয়েছে');
        } finally {
            setOfficerModalLoading(false);
        }
    };

    const addOfficerRow = () => {
        setOfficers([...officers, { name: '', profession: '', phone: '' }]);
    };

    const removeOfficerRow = (index) => {
        setOfficers(officers.filter((_, i) => i !== index));
    };

    const updateOfficerField = (index, field, value) => {
        const newOfficers = [...officers];
        newOfficers[index][field] = value;
        setOfficers(newOfficers);
    };

    // Document Functions
    const handleDocumentEntryClick = async (record) => {
        setSelectedCaseId(record.case_entry_id);
        setIsDocumentModalVisible(true);
        setDocumentModalLoading(true);
        try {
            const response = await getDocumentsByCaseEntryApi(record.case_entry_id);
            if (response.data.success) {
                setDocuments(response.data.data || []);
            } else {
                setDocuments([]);
            }
        } catch (err) {
            console.error("Document fetch error:", err);
            setDocuments([]);
            message.error("ডকুমেন্ট লোড করতে ব্যর্থ");
        } finally {
            setDocumentModalLoading(false);
        }
    };

    const handleDocumentSubmit = async () => {
        if (!docFormData.document_name || !docFormData.file) {
            message.warning("ডকুমেন্ট নাম ও ফাইল দুটোই দিতে হবে");
            return;
        }
        setDocumentModalLoading(true);
        try {
            const uploadRes = await uploadGeneralCaseFileApi(docFormData.file);
            const filePath = uploadRes.data?.data?.filePath;
            if (!filePath) {
                throw new Error("Upload did not return filePath");
            }

            const response = await addDocumentApi({
                case_entry_id: selectedCaseId,
                document_name: docFormData.document_name,
                file_url: filePath
            });

            if (response.data.success) {
                message.success("ডকুমেন্ট সফলভাবে যোগ করা হয়েছে");
                const refreshResponse = await getDocumentsByCaseEntryApi(selectedCaseId);
                if (refreshResponse.data.success) {
                    setDocuments(refreshResponse.data.data || []);
                }
                setDocFormData({ document_name: "", file: null });
            } else {
                message.error("ডকুমেন্ট যোগ করতে ব্যর্থ");
            }
        } catch (err) {
            console.error(err);
            message.error("ত্রুটি হয়েছে");
        } finally {
            setDocumentModalLoading(false);
        }
    };

    const handleDeleteDocument = async (docId) => {
        try {
            const response = await deleteDocumentApi(docId);
            if (response.data.success) {
                message.success("ডকুমেন্ট মুছে ফেলা হয়েছে");
                setDocuments(prev => prev.filter(doc => doc.file_id !== docId));
            } else {
                message.error("ডকুমেন্ট মুছতে ব্যর্থ");
            }
        } catch (err) {
            console.error(err);
            message.error("একটি ত্রুটি হয়েছে");
        }
    };

    // Action Menu Components
    const getActionMenu = (record, courtType) => (
        <Menu>
            <Menu.Item key="view" >
                <Link style={{ textDecoration: "none" }} to={`/report/single-appeal-case/view/${record.case_entry_id}`}>বিস্তারিত তথ্য</Link>
            </Menu.Item>

            <Menu.Item key="update" >
                <Link style={{ textDecoration: "none" }} to={`/appeal-court-case-update/${record.case_entry_id}`}>সংশোধন</Link>
            </Menu.Item>

            <Menu.Item key="edit" >
                <Link style={{ textDecoration: "none" }} to={`/final-result/${record.case_entry_id}`}>চূড়ান্ত রায়</Link>
            </Menu.Item>
            <Menu.Item key="hearing" onClick={() => handleHearingDateClick(record)}>শুনানি তারিখ</Menu.Item>
            <Menu.Item key="finalResult" onClick={() => fetchFinalResultData(record.case_entry_id)}>চূড়ান্ত রায় বিস্তারিত</Menu.Item>

            <Menu.Item key="comment" onClick={() => handleCommentClick(record)}>মন্তব্য</Menu.Item>
            <Menu.Item key="responsibleOfficer" onClick={() => handleResponsibleOfficerClick(record)}>দায়িত্বপ্রাপ্ত কর্মকর্তা</Menu.Item>
            <Menu.Item key="documentEntry" onClick={() => handleDocumentEntryClick(record)}>ডকুমেন্ট এন্ট্রি</Menu.Item>

        </Menu>
    );
  const handleFinalResultClick = (record) => {
        // console.log("Clicking final result for case:", record.case_entry_id);
        fetchFinalResultData(record.case_entry_id);
    };
    const getActionMenuHighcourt = (record) => (
        <Menu>


            <Menu.Item key="view">  <Link style={{ textDecoration: "none" }} to={`/report/single-high-case/view/${record.case_entry_id}`}>বিস্তারিত তথ্য  </Link></Menu.Item>
            <Menu.Item key="update">  <Link style={{ textDecoration: "none" }} to={`/high-court-case-update/${record.case_entry_id}`}>সংশোধন </Link></Menu.Item>
            <Menu.Item key="edit">  <Link style={{ textDecoration: "none" }} to={`/final-result/${record.case_entry_id}`}>চূড়ান্ত রায়  </Link> </Menu.Item>
            <Menu.Item key="hearing" onClick={() => handleHearingDateClick(record)}>শুনানি তারিখ </Menu.Item>
            <Menu.Item key="edit1" onClick={() => handleFinalResultClick(record)}>চূড়ান্ত রায় বিস্তারিত</Menu.Item>
            <Menu.Item key="comment" onClick={() => handleCommentClick(record)}>মন্তব্য</Menu.Item>
            <Menu.Item key="responsibleOfficer1" onClick={() => handleResponsibleOfficerClick(record)}>দায়িত্বপ্রাপ্ত কর্মকর্তা</Menu.Item>
            <Menu.Item key="responsibleOfficer" onClick={() => handleDocumentEntryClick(record)}>ডকুমেন্ট এন্ট্রি </Menu.Item>


        </Menu>
    );

    const getActionMenuDistrict = (record) => (
        <Menu>


            <Menu.Item key="view"> <Link to={`/report/single-case/view/${record.case_entry_id}`} style={{ textDecoration: 'none' }}> বিস্তারিত তথ্য</Link> </Menu.Item>

            {/* {(logInStatus === 1 || logInStatus === 2 || logInStatus === 7) && */}

            <Menu.Item key="update">  <Link to={`/district-court-case-update/${record.case_entry_id}`} style={{ textDecoration: 'none' }}> সংশোধন     </Link></Menu.Item>

            {/* } */}
            {/* {record.case_status == 1 && (logInStatus === 1 || logInStatus === 2 || logInStatus === 7) && */}
            <>
                <Link to={`/final-result/${record.case_entry_id}`} style={{ textDecoration: 'none' }}>
                    <Menu.Item key="edit">চূড়ান্ত রায় </Menu.Item>
                </Link>
                <Menu.Item key="hearing" onClick={() => handleHearingDateClick(record)}>শুনানি তারিখ </Menu.Item>
            </>
            {/* } */}
            {/* {record.case_status == 2 && (logInStatus === 1 || logInStatus === 2 || logInStatus === 7) && */}
            <Menu.Item key="edit" onClick={() => handleFinalResultClick(record)}>চূড়ান্ত রায় বিস্তারিত</Menu.Item>
            {/* } */}
            {/* {(logInStatus === 1 || logInStatus === 2 || logInStatus === 7) && */}
            <Menu.Item key="comment" onClick={() => handleCommentClick(record)}>মন্তব্য</Menu.Item>
            {/* } */}
            {/* {(logInStatus === 1 || logInStatus === 2 || logInStatus === 7) && */}
            <Menu.Item key="responsibleOfficer" onClick={() => handleResponsibleOfficerClick(record)}>দায়িত্বপ্রাপ্ত কর্মকর্তা</Menu.Item>
            {/* } */}
            {/* {(logInStatus === 1 || logInStatus === 2 || logInStatus === 7) && */}
            <Menu.Item key="document" onClick={() => handleDocumentEntryClick(record)}>ডকুমেন্ট এন্ট্রি </Menu.Item>
            {/* } */}

        </Menu>
    );

    // Table Columns Definitions
    const columnsAppeal = [
        { title: "ক্রম", key: "serial", width: 80, align: "center", render: (_, __, index) => toBnDigits(index + 1) },
        { title: "মামলা নং", dataIndex: "case_number", key: "case_number", width: 140, align: "center" },
        { title: "সংশ্লিষ্ট আদালতের নাম", key: "court", width: 150, render: (_, record) => <div>{record.ha_case_court_name}<br />{record.ha_case_justice_name}</div> },
        { title: "সরকারের প্রতিপক্ষের নাম", dataIndex: "petitioner_name", key: "petitioner_name", width: 180 },
        { title: "মামলাভুক্ত সংশ্লিষ্ট মুখ্য দপ্তর", dataIndex: "appelier", key: "appelier", width: 180 },
        { title: "মামলার বিষয়বস্তু", dataIndex: "case_description", key: "case_description", width: 180 },
        { title: "সর্বশেষ অবস্থা", key: "status", width: 150, render: (_, record) => <div>{record.hearing_date ? `সর্বশেষ শুনানীর তারিখ: ${record.hearing_date}` : ""}{record.next_hearing_date ? <><br />পরবর্তী শুনানীর তারিখ: {record.next_hearing_date}</> : ""}</div> },
        { title: "অবস্থা", key: "case_status", width: 150, render: (_, record) => <div>{record.case_status === 1 ? "মামলা চলমান" : "নিষ্পত্তিকৃত মামলা"}<br />{record.case_comment ? ` ও ${record.case_comment}` : ""}</div> },
        { title: "অ্যাকশন", key: "action", width: 120, align: "center", render: (_, record) => (<Dropdown overlay={getActionMenu(record, 'appeal')} trigger={['click']}><Button type="primary" size="small" style={{ backgroundColor: '#52c41a' }}>অ্যাকশন <DownOutlined /></Button></Dropdown>) }
    ];

    const columnsHighcourt = [
        { title: "ক্রম", key: "serial", width: 80, align: "center", render: (_, __, index) => toBnDigits(index + 1) },
        { title: "মামলা নং", dataIndex: "case_number", key: "case_number", width: 120, align: "center" },
        { title: "সংশ্লিষ্ট আদালতের নাম", key: "court", width: 200, render: (_, record) => <div>{record.ha_case_court_name}<br />{record.ha_case_justice_name}</div> },
        { title: "বাদী", dataIndex: "plaintiffs", key: "plaintiffs", width: 180 },
        { title: "বিবাদী", key: "defendants", width: 180, render: (_, record) => record?.defendants?.split("$").map((item, idx) => <div key={idx}>{toBnDigits(idx + 1)}. {item.trim()}</div>) },
        { title: "মামলার বিষয়বস্তু", dataIndex: "case_description", key: "case_description" },
        { title: "সর্বশেষ অবস্থা", key: "status", width: 150, render: (_, record) => <div>{record.hearing_date ? `সর্বশেষ শুনানীর তারিখ: ${record.hearing_date}` : ""}{record.next_hearing_date ? <><br />পরবর্তী শুনানীর তারিখ: {record.next_hearing_date}</> : ""}</div> },
        { title: "অবস্থা", key: "case_status", width: 150, render: (_, record) => <div>{record.case_status === 1 ? "মামলা চলমান" : "নিষ্পত্তিকৃত মামলা"}<br />{record.case_comment ? ` ও ${record.case_comment}` : ""}</div> },
        { title: "অ্যাকশন", key: "action", width: 120, align: "center", render: (_, record) => (<Dropdown overlay={getActionMenuHighcourt(record)} trigger={['click']}><Button type="primary" size="small" style={{ backgroundColor: '#52c41a' }}>অ্যাকশন <DownOutlined /></Button></Dropdown>) }
    ];
//    console.log(data)
    const columnsDistrict = [
        { title: "ক্রম", key: "serial", width: 80, align: "center", render: (_, __, index) => toBnDigits(index + 1) },
        { title: "মামলা নং", dataIndex: "case_number", key: "case_number", width: 120, align: "center" },
        { title: "জেলার নাম", dataIndex: "district_name", key: "district_name", width: 200, align: "center" },
        { title: "সংশ্লিষ্ট আদালতের নাম", dataIndex: "court_type_name", key: "court_type_name", width: 200 },
        { title: "বাদী", dataIndex: "plaintiffs", key: "plaintiffs", width: 180 },
        { title: "বিবাদী", key: "defendants", width: 180, render: (_, record) => record?.defendants?.split("$").map((item, idx) => <div key={idx}>{toBnDigits(idx + 1)}. {item.trim()}</div>) },
        { title: "মামলার বিষয়বস্তু", dataIndex: "case_description", key: "case_description" },
        { title: "সর্বশেষ অবস্থা", key: "status", width: 150, render: (_, record) => <div>{record.hearing_date ? `সর্বশেষ শুনানীর তারিখ: ${record.hearing_date}` : ""}{record.next_hearing_date ? <><br />পরবর্তী শুনানীর তারিখ: {record.next_hearing_date}</> : ""}</div> },
        { title: "অবস্থা", key: "case_status", width: 150, render: (_, record) => <div>{record.case_status === 1 ? "মামলা চলমান" : "নিষ্পত্তিকৃত মামলা"}<br />{record.case_comment ? ` ও ${record.case_comment}` : ""}</div> },
        { title: "অ্যাকশন", key: "action", width: 120, align: "center", render: (_, record) => (<Dropdown overlay={getActionMenuDistrict(record)} trigger={['click']}><Button type="primary" size="small" style={{ backgroundColor: '#52c41a' }}>অ্যাকশন <DownOutlined /></Button></Dropdown>) }
    ];

    return (
        <div className="page-wrapper">
            <Helmet><title>গুরুত্বপূর্ণ চলমান মামলা তালিকা</title></Helmet>
            <div className="content ">
                <div className="page-header">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="page-title text-center m-4" style={{ margin: '10px' }}>
                                <strong>গুরুত্বপূর্ণ চলমান মামলা তালিকা</strong>
                            </h3>
                        </div>
                    </div>
                </div>

                {loading && <div className="text-center py-5"><Spin size="large" /></div>}

                {!loading && data.appealImportantCases?.length > 0 && (
                    <>
                        <h3><strong>আপিল বিভাগ মামলা</strong></h3>
                        <Table
                            columns={columnsAppeal}
                            dataSource={data.appealImportantCases}
                            loading={loading}
                            bordered
                            pagination={false}
                            size="large"
                            rowKey="case_entry_id"
                        />
                    </>
                )}

                {!loading && data.highcourtImportantCases?.length > 0 && (
                    <>
                        <h3 className="mt-4"><strong>হাইকোর্ট বিভাগ মামলা</strong></h3>
                        <Table
                            columns={columnsHighcourt}
                            dataSource={data.highcourtImportantCases}
                            loading={loading}
                            bordered
                            pagination={false}
                            size="large"
                            rowKey="case_entry_id"
                        />
                    </>
                )}

                {!loading && data.districtImportantCases?.length > 0 && (
                    <>
                        <h3 className="mt-4"><strong>অন্যান্য অধস্তন আদালত মামলা</strong></h3>
                        <Table
                            columns={columnsDistrict}
                            dataSource={data.districtImportantCases}
                            loading={loading}
                            bordered
                            pagination={false}
                            size="large"
                            rowKey="case_entry_id"
                        />
                    </>
                )}
            </div>

            {/* Final Result Modal */}
            <AntModal
                title="চূড়ান্ত রায় বিস্তারিত"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={700}
            >
                {modalLoading ? (
                    <div className="text-center py-5"><Spin /></div>
                ) : finalResultData ? (
                    <div>
                        <div className="mb-3"><strong>মামলা নং:</strong> {toBnDigits(finalResultData.case_number)}</div>
                        <div className="mb-3"><strong>আদালত:</strong> {finalResultData.court_type_name}</div>
                        <div className="mb-3"><strong>রায় ঘোষণার তারিখ:</strong> {toBnDigits(finalResultData.judgment_date)}</div>
                        <div className="mb-3"><strong>ফলাফল:</strong> {finalResultData.outcome_code === 'GOVT_FOR' ? 'সরকারের পক্ষে' : finalResultData.outcome_code === 'GOVT_AGAINST' ? 'সরকারের বিপক্ষে' : 'N/A'}</div>
                        {finalResultData.summary_text && <div className="mb-3"><strong>রায়ের সংক্ষিপ্ত বিবরণ:</strong><br />{finalResultData.summary_text}</div>}
                    </div>
                ) : (
                    <div className="text-center py-5">কোনো তথ্য পাওয়া যায়নি</div>
                )}
            </AntModal>

            {/* Hearing Date Modal */}
            <AntModal
                title="শুনানি তারিখ যোগ করুন"
                open={isHearingModalVisible}
                onCancel={() => setIsHearingModalVisible(false)}
                footer={null}
                width={700}
            >
                {hearingModalLoading ? (
                    <Spin />
                ) : (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label>সর্বশেষ শুনানির তারিখ <span className="text-danger">*</span></label>
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format="DD/MM/YYYY"
                                    value={hearingFormData.hearing_date ? dayjs(hearingFormData.hearing_date) : null}
                                    onChange={(date) => setHearingFormData({ ...hearingFormData, hearing_date: date ? date.format('YYYY-MM-DD') : '' })}
                                />
                            </div>
                            <div className="col-md-6">
                                <label>পরবর্তী শুনানির তারিখ</label>
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format="DD/MM/YYYY"
                                    value={hearingFormData.next_hearing_date ? dayjs(hearingFormData.next_hearing_date) : null}
                                    onChange={(date) => setHearingFormData({ ...hearingFormData, next_hearing_date: date ? date.format('YYYY-MM-DD') : '' })}
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label>মন্তব্য</label>
                            <Input.TextArea rows={3} value={hearingFormData.hearing_notes} onChange={(e) => setHearingFormData({ ...hearingFormData, hearing_notes: e.target.value })} />
                        </div>
                        <Button type="primary" onClick={handleHearingFormSubmit}>যোগ করুন</Button>
                        <hr />
                        <h5>বিদ্যমান শুনানি তারিখসমূহ</h5>
                        <Table
                            dataSource={hearingDates}
                            rowKey="hearing_id"
                            pagination={false}
                            size="small"
                            columns={[
                                { title: 'ক্রম', render: (_, __, i) => toBnDigits(i + 1) },
                                { title: 'তারিখ', dataIndex: 'hearing_date', render: (d) => toBnDigits(d) },
                                { title: 'মন্তব্য', dataIndex: 'hearing_notes' },
                                {
                                    title: 'অ্যাকশন',
                                    render: (_, record) => (
                                        <Button danger size="small" onClick={() => handleDeleteHearingDate(record.hearing_id)}>মুছুন</Button>
                                    )
                                }
                            ]}
                        />
                    </>
                )}
            </AntModal>

            {/* Comment Modal */}
            <AntModal
                title="মন্তব্য যোগ করুন/সম্পাদনা করুন"
                open={isCommentModalVisible}
                onCancel={() => setIsCommentModalVisible(false)}
                footer={null}
            >
                <Input.TextArea
                    rows={6}
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    placeholder="মামলার বিষয়ে আপনার মন্তব্য লিখুন..."
                />
                <div className="mt-3">
                    <Button type="primary" loading={commentModalLoading} onClick={handleCommentSubmit}>আপডেট করুন</Button>
                </div>
            </AntModal>

            {/* Responsible Officers Modal */}
            <AntModal
                title="দায়িত্বপ্রাপ্ত কর্মকর্তা"
                open={isOfficerModalVisible}
                onCancel={() => setIsOfficerModalVisible(false)}
                footer={null}
                width={800}
            >
                {officerModalLoading ? (
                    <Spin />
                ) : (
                    <>
                        <Table
                            dataSource={officers}
                            pagination={false}
                            size="small"
                            columns={[
                                { title: 'কর্মকর্তার নাম', render: (_, __, i) => <Input value={officers[i]?.name} onChange={(e) => updateOfficerField(i, 'name', e.target.value)} placeholder="কর্মকর্তার নাম" /> },
                                { title: 'পদবি', render: (_, __, i) => <Input value={officers[i]?.profession} onChange={(e) => updateOfficerField(i, 'profession', e.target.value)} placeholder="পদবি" /> },
                                { title: 'নম্বর', render: (_, __, i) => <Input value={officers[i]?.phone} onChange={(e) => updateOfficerField(i, 'phone', e.target.value)} placeholder="মোবাইল নম্বর" /> },
                                { title: 'অ্যাকশন', render: (_, __, i) => <Button danger size="small" onClick={() => removeOfficerRow(i)}>মুছুন</Button> }
                            ]}
                        />
                        <div className="mt-3">
                            <Button onClick={addOfficerRow} style={{ marginRight: 10 }}>আরও যোগ করুন</Button>
                            <Button type="primary" onClick={handleSaveResponsibleOfficers}>সংরক্ষণ করুন</Button>
                        </div>
                    </>
                )}
            </AntModal>

            {/* Document Modal */}
            <AntModal
                title="ডকুমেন্ট যোগ করুন"
                open={isDocumentModalVisible}
                onCancel={() => setIsDocumentModalVisible(false)}
                footer={null}
                width={800}
            >
                {documentModalLoading ? (
                    <Spin />
                ) : (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <Input
                                    placeholder="ডকুমেন্ট নাম"
                                    value={docFormData.document_name}
                                    onChange={(e) => setDocFormData({ ...docFormData, document_name: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6">
                                <input type="file" className="form-control" onChange={(e) => setDocFormData({ ...docFormData, file: e.target.files[0] })} />
                            </div>
                        </div>
                        <Button type="primary" onClick={handleDocumentSubmit}>যোগ করুন</Button>
                        <hr />
                        <h5>বিদ্যমান ডকুমেন্টসমূহ</h5>
                        <Table
                            dataSource={documents}
                            rowKey="file_id"
                            pagination={false}
                            size="small"
                            columns={[
                                { title: 'ক্রম', render: (_, __, i) => i + 1 },
                                { title: 'ডকুমেন্ট নাম', dataIndex: 'file_name' },
                                {
                                    title: 'ফাইল',
                                    render: (_, r) => {
                                        const apiBase = process.env.REACT_APP_API_URL || 'https://scms.infotechitsolutionsbd.com/';
                                        const href = `${apiBase}${r.file_url}`;
                                        return <a href={href} target="_blank" rel="noopener noreferrer">দেখুন</a>;
                                    },
                                },
                                { title: 'অ্যাকশন', render: (_, r) => <Button danger size="small" onClick={() => handleDeleteDocument(r.file_id)}>ডিলিট</Button> }
                            ]}
                        />
                    </>
                )}
            </AntModal>
        </div>
    );
};

export default ImportantCase;